<template>
    <div class="float-container--bottom">
        <button class="btn btn-cancel btn-lg btn-heavy" @click="onActivateLocation" v-lang.activarGeolocalizacion>
            Activar geolocalización
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'location-off',
    props: [

    ],
    data () {
        return {
        };
    },
    computed: {
        ...mapGetters({
        })
    },
    mounted () {
        this.language = this.$getLang();
    },

    methods: {
        ...mapActions({
            callToLocationSettings: 'geolocation/callToLocationSettings'
        }),
        onActivateLocation () {
            this.callToLocationSettings();
        }
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/OnLocationOff.vue